<template>
  <div class="analysis-station-page col-block">
    <div class="option-container row-block">
      <div class="data-block row-block">
        <template v-if="conditions.filters.product">
          <div><b>品項：</b>{{ getFilterTitle('product') }}</div>
          <div :style="{ width: '50px' }"></div>
        </template>
        <template v-if="conditions.filters.country">
          <div><b>目標市場：</b>{{ getFilterTitle('country') }}</div>
          <div :style="{ width: '50px' }"></div>
        </template>
        <template v-if="dataType === 'country' && conditions.filters.year">
          <div><b>數據年份：</b>{{ getFilterTitle('year') }}</div>
          <div :style="{ width: '50px' }"></div>
        </template>
        <template v-if="dataType === 'year' && country">
          <div><b>{{ { competitiveness: '競爭國家', attraction: '市場國家', toolcompetitiveness: '競爭國家', toolattraction: '市場國家' }[analysisType] }}：</b>{{ getCountryTitle() }}</div>
          <div :style="{ width: '50px' }"></div>
        </template>
      </div>
    </div>
    <div class="content-container row-block" :style="{ flex: 1 }">
      <div class="content-tab-container col-block" :style="{ width: '48px' }">
        <div class="content-tab-block center-block" :class="{ active: tab === option.value }" v-for="(option, index) in tabOptions" :key="index">{{ option.title }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div class="main-container" :style="{ flex: 1 }">
        <analysisWeather
          v-show="tab === 'weather'"
          :dataType="dataType"
          :country="country"
          :state="state"
          :filterOptions="filterOptions"
          :conditions="conditions"
        ></analysisWeather>
      </div>
    </div>
  </div>
</template>

<script>
import analysisWeather from './weather'

export default {
  components: {
    analysisWeather
  },
  props: {
    dataType: {
      type: String,
      required: true
    },
    country: {
      Type: Object,
      default: () => null
    },
    state: {
      type: String,
      required: true
    },
    filterOptions: {
      type: Object,
      required: true
    },
    conditions: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      tab: 'weather'
    }
  },
  computed: {
    analysisType () {
      return this.$route.name
    },
    // static
    tabOptions () {
      return [
        {
          title: '天氣',
          value: 'weather'
        }
      ]
    }
  },
  methods: {
    getFilterTitle (value) {
      if (!this.conditions.filters[value]) {
        return ''
      }
      return this.filterOptions.filters.find(filter => filter.value === value).options.find(option => option.value === this.conditions.filters[value]).title
    },
    getCountryTitle () {
      if (!this.country) {
        return ''
      }
      return { competitiveness: this.country.country_name, attraction: this.country.partner_name, toolcompetitiveness: this.country.country_name, toolattraction: this.country.partner_name }[this.analysisType]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/analysis/station.vue